import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import api from "@/lib/api";

// Comparison line under a readiness result. Reads aggregates only; says plainly when the k-anonymity floor isn't met.
export default function BenchmarkLine({ change, latest }) {
  const [c, setC] = useState(null);
  useEffect(() => {
    if (!latest) return;
    api.get("/benchmark/compare", { params: { tag: latest.tag, change_type: change.change_type || "normal", overall: latest.overall } }).then((r) => setC(r.data)).catch(() => setC(null));
  }, [change.id, change.change_type, latest?.id]); // eslint-disable-line
  if (!latest || !c) return null;
  if (!c.available) return (
    <div data-testid="readiness-benchmark" data-available="false" className="mt-3 flex items-start gap-2 text-xs text-muted-foreground"><BarChart3 size={13} className="mt-0.5 shrink-0" aria-hidden="true" /><span><span className="font-bold text-subtle">Compared with other organisations:</span> {c.reason}</span></div>
  );
  return (
    <div data-testid="readiness-benchmark" data-available="true" className="mt-3 flex items-start gap-2 text-xs text-subtle"><BarChart3 size={13} className="mt-0.5 shrink-0 text-accent-600" aria-hidden="true" />
      <span><span className="font-bold text-foreground">{latest.target_name} at {latest.overall}%</span> is <span className="font-bold">{c.overall.position}</span> for {c.cohort.change_type} changes at {latest.tag.replace("_", " ")} (median {c.overall.p50}%, {c.distinct_orgs} organisations, {c.changes} changes).</span>
    </div>
  );
}
